export const ADD_DASHBOARD_FILTER = "ADD_DASHBOARD_FILTER R";
export const REMOVE_DASHBOARD_FILTER = "REMOVE_DASHBOARD_FILTER";
export const TOGGLE_FETCH_MEDICAL_STATUS = "TOGGLE_FETCH_MEDICAL_STATUS";
export const SET_SELECTED = "SET_SELECTED";

export const setSelected = (dispatch, obj) =>
  dispatch({ type: SET_SELECTED, payload: obj });

export const toggleFetchMedicalStatus = (dispatch, bool) =>
  dispatch({ type: TOGGLE_FETCH_MEDICAL_STATUS, payload: bool });
